import React from 'react'
import loadable from '@loadable/component'
import paths from 'app/paths'
import { getPathWithoutBase } from 'components/tabs'
import { Routes, Route } from 'react-router-dom'
import RouteAuthorization from 'app/route-authorization'
import DelayedRedirect from 'components/delayed-redirect'

import SubsidiariesPage from './pages/subsidiaries'
const InsightsPage = loadable(() => import(/* webpackPrefetch: true */ './pages/insights'))

const salt = 'corporation'

const CorporationRouting = () => {
    const { base } = paths.corporation
    const getRelativePath = getPathWithoutBase(base)

    return (
        <Routes>
            <Route
                path={getRelativePath(base)}
                element={(
                    <RouteAuthorization permissions={['subsidiaries:manage']}>
                        <SubsidiariesPage salt={`${salt}:page:subsidiaries`} />
                    </RouteAuthorization>
                )} />

            <Route
                path={getRelativePath(paths.corporation.insights)}
                element={(
                    <RouteAuthorization
                        module="insights"
                        permissions={['subsidiaries:manage']}>
                        <InsightsPage salt={`${salt}:page:insights`} />
                    </RouteAuthorization>
                )} />
            <Route
                path="*"
                element={<DelayedRedirect to={base} />} />
        </Routes>
    )
}

export default CorporationRouting